import { TopBar } from "@components/TopBar";
import { Button, LoadingSkeleton, Row } from "@narmi/design_system";
import Filters from "byzantine/src/filters";
import { useState } from "react";
import { $staffApi } from "../../api";
import { EditProductModal } from "./EditProductModal";
import { InstitutionSettingsBasePage } from "./InstitutionSettingsBasePage";
import { InstitutionSettingsTabList } from "./InstitutionSettingsTabNavigation";

export const InstitutionSettings = ({ initialCategory }: { initialCategory?: string }) => {
  const [editProductsOpen, setEditProductsOpen] = useState(false);
  const [selectedCategory, setSelectedCategory] = useState(initialCategory);

  const { data: institutionCategoriesWithCount, isLoading: isCategoriesLoading } =
    $staffApi.useQuery("get", "/api/institution_settings/categories/");

  if (isCategoriesLoading) {
    return <LoadingSkeleton isLoading={true} />;
  }

  const institutionCategories = institutionCategoriesWithCount?.map((c) => c.name) ?? [];

  return (
    <InstitutionSettingsBasePage
      topBar={
        <TopBar.Compact>
          <TopBar.Breadcrumb>Configuration</TopBar.Breadcrumb>
          <TopBar.Breadcrumb to="/configuration/institution_settings">
            Institution Settings
          </TopBar.Breadcrumb>
          {selectedCategory && (
            <TopBar.Breadcrumb>{Filters.humanize(selectedCategory)}</TopBar.Breadcrumb>
          )}
        </TopBar.Compact>
      }
    >
      <>
        <Row>
          <Row.Item>
            <div className="nds-typography margin--bottom--xl">
              <h2 className="margin--bottom--xs">Institution settings</h2>
              <div>Turn products on for this institution, and then configure each one.</div>
            </div>
          </Row.Item>

          <Row.Item shrink>
            <Button
              size="s"
              kind="tertiary"
              label="Edit products"
              onClick={() => setEditProductsOpen(true)}
            />
          </Row.Item>
        </Row>

        <InstitutionSettingsTabList
          institutionCategories={institutionCategories}
          initialCategory={initialCategory}
          onCategoryChange={setSelectedCategory}
        />
        <EditProductModal
          open={editProductsOpen}
          onSuccess={() => setEditProductsOpen(false)}
          onExit={() => setEditProductsOpen(false)}
        />
      </>
    </InstitutionSettingsBasePage>
  );
};
